import { render, staticRenderFns } from "./PurchaseLogs.vue?vue&type=template&id=7e4cd0a7"
import script from "./PurchaseLogs.vue?vue&type=script&lang=js"
export * from "./PurchaseLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports